//
// Gallery Controller
//

import { onClick } from '../utilities'

export default class GalleryController {
  public static readonly shared = new GalleryController()

  // MARK: - Object Lifecycle

  private constructor() {
    onClick('.pctr-vehicle-for-sale-featured-image', this.onClickFeaturedImage.bind(this))
  }

  // MARK: - Clicking

  private onClickFeaturedImage() {
    const anchorElement = document.querySelector(
      '.pctr-vehicle-for-sale-gallery .uabb-photo-gallery-item:first-child a'
    )
    if (anchorElement instanceof HTMLAnchorElement !== true) return

    anchorElement.click()
  }
}
